export default [
  {
    path: '/main/movementtype',
    meta: {
      tag: 'list_movementtype',
      name: 'Tipos de Movimentação de Ativo',
      breadcrumb: 'Tipos de Movimentação de Ativo'
    },
    component: () => import(/* webpackChunkName: "movementtype-list" */ '@/views/main/settings/stock-registers/movementType/Index.vue'),
    children: [
      {
        path: '',
        name: 'listmovementtype',
        meta: {
          tag: 'list_movementtype',
          menu: 'settings',
          name: 'Tipos de Movimentação de Ativo'
        },
        component: () => import(/* webpackChunkName: "movementtype-list" */ '@/views/main/settings/stock-registers/movementType/List.vue'),
      },
      {
        path: '/main/movementtype/add',
        name: 'addmovementtype',
        meta: {
          tag: 'add_movementtype',
          menu: 'settings',
          name: 'Adicionar | Tipo de Movimentação de Ativo',
          breadcrumb: 'Adicionar Tipo de Movimentação de Ativo'
        },
        component: () => import(/* webpackChunkName: "movementtype-add" */ '@/views/main/settings/stock-registers/movementType/Add.vue')
      },
      {
        path: '/main/movementtype/:id',
        name: 'editmovementtype',
        meta: {
          tag: 'edit_movementtype',
          menu: 'settings',
          name: 'Editar | Tipo de Movimentação de Ativo',
          breadcrumb: 'Editar Tipo de Movimentação de Ativo'
        },
        component: () => import(/* webpackChunkName: "movementtype-edit" */ '@/views/main/settings/stock-registers/movementType/Edit.vue')
      }
    ]
  }
]